import HttpClient from "./HttpClient";
import { Contribution } from "@/models/Contribution";
import { Credit } from "@/models/Credit";
import { AxiosResponse } from "axios";

class HomeRepository {
  private http = HttpClient.getInstance();

  /**
   * Fetch user data from the API.
   * @param authBasic - Basic authentication token.
   * @returns A promise with the fetched user data.
   */
  async fetchUserData(authBasic: string): Promise<AxiosResponse> {
    try {
      const response = await this.http.get("/api/v1/documents/associates/all", {
        headers: {
          Authorization: `Basic ${authBasic}`,
          "Content-Type": "application/json",
        },
      });
      return response as AxiosResponse;
    } catch (error) {
      console.error("Error fetching user data:", error);
      throw error;
    }
  }
}

export default new HomeRepository();
